export const PALETTE = ["#0EA5E9", "#EC4899", "#10B981", "#F59E0B", "#8B5CF6", "#F97316", "#14B8A6", "#EF4444"];
export const UNKNOWN = "var(--o-muted2)";

// The kinds of contribution the Observer makes (its system prompt defines them).
export const MOVES = {
  agreement: { label: "Common ground", color: "#10B981" },
  tension: { label: "Tension", color: "#F43F5E" },
  avoided_decision: { label: "Avoided decision", color: "#F59E0B" },
  assumption: { label: "Assumption", color: "#8B5CF6" },
  risk: { label: "Risk", color: "#F97316" },
  evidence: { label: "Check the facts", color: "#14B8A6" },
  unconsidered: { label: "Not considered", color: "#0EA5E9" },
  question: { label: "Question to ask", color: "#EC4899" },
  cheap_step: { label: "Cheap next step", color: "#84CC16" },
};

export const moveLabel = (m) => MOVES[m]?.label || m || "—";

export function fmtClock(sec) {
  const s = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(r).padStart(2, "0");
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function fmtLatency(ms) {
  if (ms == null) return "—";
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${ms}ms`;
}

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9\u0900-\u097f ]/g, " ").trim();

export function makeSpeakerColor(participants) {
  const known = (participants || []).map((p, i) => ({ key: norm(p.name), first: norm(p.name).split(" ")[0], color: PALETTE[i % PALETTE.length] }));
  const extra = new Map();
  return (speaker) => {
    const n = norm(speaker);
    if (!n || n === "unknown" || n.startsWith("unknown")) return UNKNOWN;
    const hit = known.find((k) => k.key === n) || known.find((k) => k.first && (n.split(" ")[0] === k.first || n.includes(k.key)));
    if (hit) return hit.color;
    if (!extra.has(n)) extra.set(n, PALETTE[(known.length + extra.size) % PALETTE.length]);
    return extra.get(n);
  };
}
